<template>
    <PageContent :title="formTitle">
        <div>个人档案</div>
    </PageContent>
</template>

<script>

export default {
    components: {

    },
    props: {

    },
    data() {
        return {
            formTitle: '常用选择框',
            vo: { 'id': 'plat' },
            canEdit: 1,
            forceUpdate: false,
            morning: null,
            curTime: null
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped lang="scss">
.tblbl-left{
    ::v-deep .el-button{
        float:right;
    }
}
</style>
